import { Box, Button, Container, Grid, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common'
import Shoot from '../../../../layout/Shoot';
import axios from 'axios';


const Comprehensivedesign = ({onLoaded, AllProduct}) => {
    const theme = useTheme();

    // const [AllProduct, setAllProduct] = useState([]);
    // const fetchFilteredProducts = async (filters) => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?page=${1}&limit=${3}`);
    //         setAllProduct(response.data.data);
    //     } catch (error) {
    //         console.error('Error fetching products:', error);
    //     } finally {
    //         onLoaded();
    //     }
    // };
    // useEffect(() => {
    //     fetchFilteredProducts();
    // }, [])

    return (
        <>
            <Box sx={{
                backgroundImage: 'url(/images/Custom-Made/section-bg-1.jpg)',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'relative',
                // padding: { xs: '40px 0px 40px 0px', sm: '70px 0px 70px 0px', md: '120px 0px 120px 0px', lg: '50px 0px50px 0px' },
                zIndex: '1',
                backgroundAttachment: 'fixed',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: '-1',
                    backgroundColor: '#000000d4',
                    top: '0'
                }
            }}>
                <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid xs={12} lg={6}>
                        <Box sx={{ padding: { sm: '60px 45px', xs: '30px 18px' } }}>

                            <Box sx={{ textAlign: 'end' }}>
                                <Box sx={{ textAlign: { sm: 'end', xs: 'center' }, pb: 3 }}>
                                    <CommonTitle margin={'0 0 10px 0'} text={'supreme quality'} />
                                    <CommonHeading text={'Stylish Men’s Clothing for Every Occasion'} />
                                </Box>
                                <Typography sx={{
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontFamily: theme.palette.typography.fontFamily1,
                                    mb: { xl: '50px', lg: '42px' },
                                    lineHeight: { md: '1.9', xs: '1.6' },
                                    // width: {sm:'60%',xs:'100%'},
                                    textAlign: 'end'
                                }}>
                                    Premium fabrics crafted for comfort and confidence. Explore timeless designs that elevate your everyday look. Shop the best in modern menswear today.
                                </Typography>
                            </Box>
                            <Box sx={{ mt: 8 }} maxWidth='xl'>
                                <Grid container>
                                    {
                                        AllProduct.map((val) => {
                                            return (
                                                <Grid xs={12} sm={6} md={4}>
                                                    <Shoot primaryImg={val?.ProductImage} title={val?.ClothesType} price={val.ProductPrice} Pricefontsize={'12px'} TitlefontSize={'18px'} buttonwidth={'100%'} DiscountPrice={val.DiscountPrice} ShirtMeter={val?.ShirtMeter} slug={val.unqid}
                                                        PaintMeter={val?.PaintMeter} FabricType={val?.FabricType} TrouserMeter={val?.TrouserMeter} KurtaMeter={val?.KurtaMeter}
                                                    />
                                                    {/* <Shoot primaryImg={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + val?.ProductImage} title={val?.ClothesType} price={val.ProductPrice} Pricefontsize={'12px'} TitlefontSize={'18px'} buttonwidth={'100%'} DiscountPrice={val.DiscountPrice} ShirtMeter={val?.ShirtMeter} slug={val.unqid}
                                                        PaintMeter={val?.PaintMeter}
                                                    /> */}
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid xs={12} lg={6}>
                        <Box sx={{ position: 'relative' }} >
                            <img src='/images/Comprehensivedesign/inner-section-right-img.jpg' width='100%' height='100%' />
                            {/* <Box sx={{ backgroundImage: 'linear-gradient(180deg, #BB9D7B00 0%, #000000 100%)', position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, zIndex: 1, display: 'flex', justifyContent: 'end', flexDirection: 'column' }}>
                                <Box sx={{ p: { sm: 6, xs: 3 }, mb: 4 }}>
                                    <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: { md: '38px', xs: '20px' }, pb: '20px' }}>
                                        Get 50% OFF on first class suits
                                    </Typography>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: { xl: '100%', lg: '85%', md: '60%' },
                                        // maxWidth: '400px',
                                        border: '1px solid #fff',
                                        borderRadius: '4px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        mx: 'auto',
                                        marginBottom: '10px',
                                    }}
                                        noValidate
                                        autoComplete="off"

                                    >
                                        <TextField
                                            placeholder="Enter your email to subscribe**"
                                            variant="outlined"
                                            sx={{
                                                flexGrow: 1,
                                                padding: { sm: '5px 240px 2px 20px', xs: '5px 100px 2px 5px' },

                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: 0,
                                                    border: 'none',
                                                    backgroundColor: 'transparent',
                                                    color: '#fff',
                                                    width: '100%',
                                                    '& fieldset': {
                                                        border: 'none'
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#fff',
                                                    }
                                                },
                                            }}
                                        />
                                        <Box sx={{ position: 'absolute', right: '7px', top: '7px', width: '26%' }}>
                                            <DesignBtn padding={'10px 35px 10px'} text={'SUBSCRIBE'} />
                                        </Box>
                                    </Box>
                                    <Typography variant="caption" sx={{ marginTop: '14px', fontFamily: theme.palette.typography.fontFamily1, color: '#fff', fontSize: { sm: '16px', xs: '12px' } }}>
                                        *Use code CLASSIC at checkout through 4/10. Exclusions apply.
                                    </Typography>
                                </Box>
                            </Box> */}
                        </Box>
                    </Grid>
                </Grid>

            </Box>
        </>
    )
}

export default Comprehensivedesign